/**
 * created by xcc
 Remark 备注
 *
 */
import React, {Component} from 'react';
import {Modal, Input} from "antd";
import {message} from "../../../../../utils/message";
import BaseComponent from "../../../../../base/BaseComponent";

const {TextArea} = Input;
export default class Remark extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            remark: "",
            btnItem: {},
            dataItem: {},
        }
    }

    callback = () => {
    }

    show(record, btnItem, callback) {
        this.callback = callback;
        this.setState({
            visible: true,
            btnItem,
            dataItem: record,
            remark: "",
            strLength: 0
        })
    }

    onOk = () => {
        if (!this.state.remark || !this.state.remark.trim().length) {
            message.warn("请输入处理意见");
            return;
        }
        let body = {
            remark: this.state.remark,
            id: this.state.dataItem.id
        }
        this.request({
            url: '/cm-sites-media-consumer/safety/management/remind',
            body: body,
            method: "post",
            callBack: (data) => {
                if (data) {
                    message.success(`${this.state.btnItem.name}成功`);
                    this.callback && this.callback();
                    this.setState({
                        visible: false
                    })
                } else {
                    message.warn(`${this.state.btnItem.name}失败`);
                }
            },
            errorCallBack: (e) => {
            },
        })
    };

    onCancel = () => {
        this.setState({
            visible: false
        })
    };

    onChange = (e) => {
        this.state.strLength = e.target.value.length;
        this.setState({
            remark: e.target.value
        })
    };

    render() {
        let {maxLength = 500, strLength = 0} = this.state;
        return (
            <Modal
                visible={this.state.visible}
                title={"处理意见"}
                onOk={this.onOk}
                onCancel={this.onCancel}
                okText={"提交"}
                maskClosable={false}
                centered
            >
                <>
                    <TextArea value={this.state.remark} placeholder={"请输入"} rows={6}
                              maxLength={maxLength}
                              onChange={this.onChange}
                              ref={(remarksTextArea) => this.remarksTextArea = remarksTextArea}/>
                    <div style={{textAlign: "right"}}>{strLength}/{maxLength}</div>
                </>
            </Modal>
        )
    }

}